// Brand Colors – mirrored from mobile app
export const COLORS = {
  primary: "#102232",
  secondary: "#5bb2d4",
  events: "#5bb2d4",
  groups: "#8B5CF6",
  stats: "#006d24",
  activity: "#b45309",
  chat: "#EC4899",
  friends: "#0d9488",
  parimutuel: "#d97706",
  success: "#006d24",
  warning: "#b45309",
  error: "#ba1a1a",
  white: "#ffffff",
  surface: "#f8fafc",
  border: "#e2e8f0",
  textPrimary: "#102232",
  textSecondary: "#64748b",
} as const;

export type ColorKey = keyof typeof COLORS;
